var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-page-designer',{attrs:{"value":_vm.value,"widgets":_vm.widgets,"upload":_vm.handleUpload,"upload-option":_vm.uploadOption,"locale":"cn"},on:{"save":_vm.handleSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }